import ds, {dsc, ___} from '../utils/daoService/DaoServiceClientES6Adapter'

const ebFtPlan = ds.QEbFtPlan.using(dsc)

// 通过ebOrderId查询
ebFtPlan.getCountByEbOrderId = function (ebOrderId) {
  return ebFtPlan
    .select(ebFtPlan.ebFtPlanId)
    .where(ebFtPlan.ebOrderId.eq$(ebOrderId))
    .tag('getCountByEbOrderId')
    .execute(ebOrderId)
}
export default ebFtPlan
